export default function install (Vue) {
  Vue.prototype.$transition = Vue.transition = {
    currentLevel: 0,
    name: 'up',
    changeAnimationName (name) {
      Vue.set(Vue.transition, 'name', name)
    }
  }
}
